// extracted by mini-css-extract-plugin
module.exports = {"policyMarineSection":"PolicyMarineInfo_policyMarineSection__2weTY","marineInfoContainer":"PolicyMarineInfo_marineInfoContainer__3xpFB"};